import { BigNumber } from 'bignumber.js';

export const format = (value: string | number, decimals = 2) => {
  if (!value || value === '...') {
    return value;
  }
  return new BigNumber(value).toFormat(decimals);
};

export const formatAmount = (amount: number | string) => {
  const absNum = BigNumber(amount).absoluteValue().toNumber();

  if (absNum >= 1e6) {
    return (absNum / 1e6).toFixed(1).replace(/\.?0+$/, '') + 'M';
  } else if (absNum >= 1e3) {
    return (absNum / 1e3).toFixed(1).replace(/\.?0+$/, '') + 'k';
  } else {
    return BigNumber(absNum).decimalPlaces(2);
  }
};

export const formatAmountFloor = (amount: number | string) => {
  const absNum = BigNumber(amount || 0)
    .absoluteValue()
    .toNumber();

  if (absNum >= 1e12) {
    const floored = Math.floor(absNum / 1e11) / 10;
    return floored.toString().replace(/\.?0+$/, '') + 'T';
  } else if (absNum >= 1e9) {
    const floored = Math.floor(absNum / 1e8) / 10;
    return floored.toString().replace(/\.?0+$/, '') + 'B';
  } else if (absNum >= 1e6) {
    const floored = Math.floor(absNum / 1e5) / 10;
    return floored.toString().replace(/\.?0+$/, '') + 'M';
  } else if (absNum >= 1e3) {
    const floored = Math.floor(absNum / 100) / 10;
    return floored.toString().replace(/\.0+$/, '') + 'k';
  } else {
    return BigNumber(Math.floor(absNum * 100) / 100).toFixed();
  }
};

export function formatPrice(priceAmount: number | string) {
  const number = BigNumber(priceAmount);

  if (number.minus(number.integerValue()).isZero()) {
    return number.toFormat(0);
  } else {
    return number.toFormat(2);
  }
}

export function addThousandSeparators(value: number | null) {
  return BigNumber(Math.floor(value || 0)).toFormat(0, {
    groupSize: 3,
    groupSeparator: ' ',
    decimalSeparator: '.'
  });
}

export function toCamelCase(str: string): string {
  if (!str || typeof str !== 'string') return '';

  return str
    .trim()
    .toLowerCase()
    .split(/[\s\-_]+/)
    .filter((word) => word.length > 0)
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
}
